import React from "react";

interface CurrencyFormatterProps {
  value: string | number;
  className?: string;
}

export const CurrencyFormatter: React.FC<CurrencyFormatterProps> = ({
  value,
  className = "text-right",
}) => {
  const formattedValue = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(parseFloat(String(value)) || 0);

  return <div className={className}>{formattedValue}</div>;
};
